import _ from "lodash";
import React, { useState, useMemo } from "react";
import { useI18n } from "Hooks";
import { TextAreaInput } from "@toddle-edu/ds-web";
import { fontStyles } from "@toddle-edu/ds-theme";
import classes from "./CriteriaComment.scss";

const styles = {
  textAreaInput: {
    fontSize: "1.4rem",
    lineHeight: "2.4rem",
    padding: "12px 16px",
    minWidth: "320px",
    ...fontStyles.small,
  },
};

const CriteriaComment = ({
  criteriaRemarks,
  updateComment,
  disabled = false,
  inputRef,
  textAreaInputStyle,
  testId,
}) => {
  const { t } = useI18n(["common"]);

  const [criteriaComment, setCriteriaComment] = useState(
    criteriaRemarks?.message ?? ""
  );

  const onChangeDebounce = useMemo(
    () =>
      _.debounce(value => {
        updateComment(value);
      }, 300),
    []
  );

  const onChange = e => {
    setCriteriaComment(e.target.value);
    onChangeDebounce(e.target.value);
  };

  return (
    <div className={classes.container}>
      <TextAreaInput
        ref={inputRef}
        name={"remarks"}
        value={criteriaComment}
        onChange={onChange}
        placeholder={t("common:enter_comment_here")}
        disabled={disabled}
        minRows={1}
        style={textAreaInputStyle ?? styles.textAreaInput}
        testId={`${testId}-criteriaComment`}
      />
    </div>
  );
};
export default CriteriaComment;
